"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=e(require("styled-components")).default.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 99999;
  padding: 0;
  box-sizing: border-box;
  transition: all 0.4s ease-in-out;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-name: ${({open:e})=>e?"modalEnter":"modalExit"};

  .inner {
    width: 100%;
    max-width: ${({theme:e})=>e.widths.large};
    max-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: ${({theme:e,fullscreen:t})=>t?"0":e.spacing.large};
    box-sizing: border-box;

    @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
      max-width: calc(
        (100vh - (${({theme:e})=>e.spacing.large} * 2)) * 1.45
      );
    }

    figure {
      overflow: hidden;
    }
  }

  .backdrop {
    position: absolute;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.85);
    top: 0;
    left: 0;
    z-index: -1;
  }

  header {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    button {
      background: transparent;
      border: none;
      margin-right: -0.5rem;
      cursor: pointer;

      svg {
        path {
          fill: ${({theme:e})=>e.colors.primary.light};
        }
      }
    }
  }

  .content {
    min-height: 50%;
    max-height: calc(100vh - ${({theme:e})=>e.spacing.large});
    overflow: auto;
    iframe {
      width: 100%;
    }
  }

  @keyframes modalEnter {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes modalExit {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;module.exports=t;
//# sourceMappingURL=styled.js.map
